/* eslint-disable indent */

import * as Utils from './savanna_utils.js';

function isVowel(c) {
	return [
		'a', 'e', 'i', 'o', 'u'
	].indexOf(c.toLowerCase()) !== -1;
}

// puts a or an infront of word depending if it start with vowel
function parseWordArticle(word) {
	if (isVowel(word[0]))
	{
		return 'an ' + word;
	}
	else
	{
		return 'a ' + word;
	}
}

/** make_nice here will replace today's date with "today" and yesterday with "yesterday"**/
function get_nice_full_date(date_obj) {
	let days = [
		'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
	];
	let months = [
		'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
	];

	let today = new Date();
	let yesterday = new Date();
	yesterday.setDate(yesterday.getDate() - 1);
	let tomorrow = new Date();
	tomorrow.setDate(tomorrow.getDate() + 1);

	if (date_obj.getDate() === today.getDate() && date_obj.getMonth() === today.getMonth() && date_obj.getFullYear() === today.getFullYear())
	{
		return 'Today';
	} else if (date_obj.getDate() === yesterday.getDate() && date_obj.getMonth() === yesterday.getMonth() && date_obj.getFullYear() === yesterday.getFullYear())
	{
		return 'Yesterday';
	} else if (date_obj.getDate() === tomorrow.getDate() && date_obj.getMonth() === tomorrow.getMonth() && date_obj.getFullYear() === tomorrow.getFullYear())
	{
		return 'Tomorrow';
	} else
	{
		return days[date_obj.getDay()] + ' ' + date_obj.getDate() + ' ' + months[date_obj.getMonth()] + ' ' + date_obj.getFullYear();
	}
}

// this parses system logs
// records here is list query results ( from v_system_logs ), logged_dates_array is a observable array containing a list of dates in format "2017-01-01"
export default function parseLogs(records, logged_dates_array)
{
	for (let a = 0; a < records.length; a++)
	{
		// find out if the date changes so we can create headers in html view
		records[a].isNewDate = false;
		if (a === 0 || (records[a - 1] != null && records[a].log_date !== records[a - 1].log_date && logged_dates_array.indexOf(records[a].log_date) === -1))
		{
			records[a].isNewDate = true;
			records[a].displayDate = get_nice_full_date(new Date(records[a].log_date), true);
			logged_dates_array.push(records[a].log_date);
		}

		// do the parsing
		records[a].parseMessage = '';
		records[a].parseTime = Utils.get_time(new Date(records[a].timestamp));
		records[a].parseChanges = '';
		records[a].importantDisplayInfo = '';
		records[a].importantDevInfo = '';
		var employee_name_link = '';

		if (records[a].employee_id == null)
		{
			// try the grape user
			employee_name_link = records[a].username;
			if (records[a].fullnames != null) employee_name_link += ' (' + records[a].fullnames + ')';
		} else
		{
			employee_name_link = "<a href='#/employee/view/" + records[a].employee_id + "'>" + records[a].firstname + ' ' + records[a].surname + '</a>';
		}
		var employee_affected_name_link = "<a href='#/employee/view/" + records[a].affected_employee_id + "'>" + records[a].a_firstname + ' ' + records[a].a_surname + '</a>';

		var employee_involved_name_link = "<a href='#/employee/view/" + records[a].involved_employee_id + "'>" + records[a].i_firstname + ' ' + records[a].i_surname + '</a>';

		switch (records[a].action_type)
		{
			case 'UPDATE': {
				if (records[a].affected_employee_id == null)
				{
					records[a].parseMessage = employee_name_link + " has made a <span class='orange'>change</span> to " + parseWordArticle(records[a].title) + '.';
				} else
				{
					records[a].parseMessage = employee_name_link + " has made a <span class='orange'>change</span> to " + employee_affected_name_link + "'s " + records[a].title + '.';
				}
				// parse the changes
				if (records[a].new_data != null) records[a].parseChanges += "<div class='log_important_item'>With the following changes:</div>";
				$.each(records[a].new_data, function (k, v) {
					records[a].parseChanges += "<div class='log_change_item_holder'>";
					records[a].parseChanges += "<div class='log_change_item'>" + k + ':</div>';
					records[a].parseChanges += "<span class='log_old_value' >" + records[a].old_data[k] + "</span> <span class = 'fa fa-arrow-right grey'></span> <span class='log_new_value'>" + v + '</span>';
					records[a].parseChanges += '</div>';
				});
				records[a].parseChanges += "<div class='clear_all'></div>";

				// display info header
				if (records[a].important_display_fields != null) records[a].importantDisplayInfo += "<div class='log_important_item'>Where the criteria is as follows:</div>";

				break;
			}
			case 'ARCHIVE': {
				if (records[a].affected_employee_id == null)
				{
					records[a].parseMessage = employee_name_link + " has <span class='grey'>archived</span> " + parseWordArticle(records[a].title) + '.';
				} else
				{
					records[a].parseMessage = employee_name_link + " has <span class='grey'>archived</span> " + records[a].title + ' for ' + employee_affected_name_link;
				}

				// display info header
				if (records[a].important_display_fields != null) records[a].importantDisplayInfo += "<div class='log_important_item'>Where the criteria is as follows:</div>";
				break;
			}
			case 'REPROCESS': {
				if (records[a].affected_employee_id == null)
				{
					records[a].parseMessage = employee_name_link + " has <span class='orange'>reprocessed and unlocked</span> " + parseWordArticle(records[a].title) + ' entry.';
				} else
				{
					records[a].parseMessage = employee_name_link + " has <span class='orange'>reprocessed and unlocked</span> " + parseWordArticle(records[a].title) + ' for ' + employee_affected_name_link;
				}

				// display info header
				if (records[a].important_display_fields != null) records[a].importantDisplayInfo += "<div class='log_important_item'>Where the criteria is as follows:</div>";
				break;
			}
			case 'CONVERT': {
				if (records[a].affected_employee_id == null)
				{
					records[a].parseMessage = employee_name_link + " has <span class='orange'>converted</span> to " + parseWordArticle(records[a].title) + '.';
				} else
				{
					records[a].parseMessage = employee_name_link + " has <span class='orange'>converted</span> " + employee_affected_name_link + "'s " + records[a].title + '.';
				}
				// parse the changes
				if (records[a].new_data != null) records[a].parseChanges += "<div class='log_important_item'>With the following changes:</div>";
				$.each(records[a].new_data, function (k, v) {
					records[a].parseChanges += "<div class='log_change_item_holder'>";
					records[a].parseChanges += "<div class='log_change_item'>" + k + ':</div>';
					records[a].parseChanges += "<span class='log_old_value' >" + records[a].old_data[k] + "</span> <span class = 'fa fa-arrow-right grey'></span> <span class='log_new_value'>" + v + '</span>';
					records[a].parseChanges += '</div>';
				});
				records[a].parseChanges += "<div class='clear_all'></div>";

				// display info header
				if (records[a].important_display_fields != null) records[a].importantDisplayInfo += "<div class='log_important_item'>Where the criteria is as follows:</div>";

				break;
			}
			case 'INSERT': {
				if (records[a].affected_employee_id == null)
				{
					records[a].parseMessage = employee_name_link + " has <span class='green'>inserted</span> " + parseWordArticle(records[a].title) + '.';
				} else
				{
					// if there is a 3rd person involved
					if (records[a].involved_employee_id == null)
					{
						records[a].parseMessage = employee_name_link + " has <span class='green'>inserted</span> " + parseWordArticle(records[a].title) + ' for ' + employee_affected_name_link + '.';
					} else
					{
						records[a].parseMessage = employee_name_link + " has <span class='green'>inserted</span> " + employee_involved_name_link + ' as ' + parseWordArticle(records[a].title) + ' for ' + employee_affected_name_link + '.';
					}
				}

				// display info header
				if (records[a].important_display_fields != null) records[a].importantDisplayInfo += "<div class='log_important_item'>Where the criteria is as follows:</div>";
				break;
			}
			case 'UPLOAD': {
				if (records[a].affected_employee_id == null)
				{
					records[a].parseMessage = employee_name_link + " has <span class='green'>uploaded</span> " + parseWordArticle(records[a].title) + '.';
				} else
				{
					records[a].parseMessage = employee_name_link + " has <span class='green'>uploaded</span> " + parseWordArticle(records[a].title) + ' for ' + employee_affected_name_link + '.';
				}

				// display info header
				if (records[a].important_display_fields != null) records[a].importantDisplayInfo += "<div class='log_important_item'>Where the criteria is as follows:</div>";
				break;
			}
			case 'DELETE': {
				if (records[a].affected_employee_id == null)
				{
					records[a].parseMessage = employee_name_link + " has <span class='red'>removed</span> " + parseWordArticle(records[a].title) + '.';
				} else
				{
					// if there is a 3rd person involved
					if (records[a].involved_employee_id == null)
					{
						records[a].parseMessage = employee_name_link + " has <span class='red'>removed</span> " + parseWordArticle(records[a].title) + ' from ' + employee_affected_name_link;
					} else
					{
						records[a].parseMessage = employee_name_link + " has <span class='red'>removed</span> " + employee_involved_name_link + ' as ' + parseWordArticle(records[a].title) + ' from ' + employee_affected_name_link;
					}
				}

				// display info header
				if (records[a].important_display_fields != null) records[a].importantDisplayInfo += "<div class='log_important_item'>Where the criteria is as follows:</div>";
				break;
			}
			case 'UNDO': {
				if (records[a].affected_employee_id == null)
				{
					records[a].parseMessage = employee_name_link + " has <span class='red'>reverted</span> " + parseWordArticle(records[a].title) + '.';
				} else
				{
					// if there is a 3rd person involved
					if (records[a].involved_employee_id == null)
					{
						records[a].parseMessage = employee_name_link + " has <span class='red'>reverted</span> " + parseWordArticle(records[a].title) + ' for ' + employee_affected_name_link;
					} else
					{
						records[a].parseMessage = employee_name_link + " has <span class='red'>reverted</span> " + employee_involved_name_link + ' as ' + parseWordArticle(records[a].title) + ' for ' + employee_affected_name_link;
					}
				}

				// display info header
				if (records[a].important_display_fields != null) records[a].importantDisplayInfo += "<div class='log_important_item'>Where the criteria is as follows:</div>";
				break;
			}
			case 'CANCEL': {
				if (records[a].affected_employee_id == null)
				{
					records[a].parseMessage = employee_name_link + " has <span class='red'>cancelled</span> " + parseWordArticle(records[a].title) + '.';
				} else
				{
					// if there is a 3rd person involved
					if (records[a].involved_employee_id == null)
					{
						records[a].parseMessage = employee_name_link + " has <span class='red'>cancelled</span> " + parseWordArticle(records[a].title) + ' for ' + employee_affected_name_link;
					} else
					{
						records[a].parseMessage = employee_name_link + " has <span class='red'>cancelled</span> " + employee_involved_name_link + ' as ' + parseWordArticle(records[a].title) + ' for ' + employee_affected_name_link;
					}
				}

				// display info header
				if (records[a].important_display_fields != null) records[a].importantDisplayInfo += "<div class='log_important_item'>Where the criteria is as follows:</div>";
				break;
			}
			case 'END': {
				if (records[a].affected_employee_id == null)
				{
					records[a].parseMessage = employee_name_link + " has <span class='red'>ended</span> " + parseWordArticle(records[a].title) + ' entry.';
				} else
				{
					records[a].parseMessage = employee_name_link + " has <span class='red'>ended</span> " + records[a].title + ' for ' + employee_affected_name_link;
				}

				// display info header
				if (records[a].important_display_fields != null) records[a].importantDisplayInfo += "<div class='log_important_item'>Where the criteria is as follows:</div>";
				break;
			}
			case 'REQUEST': {
				// if ( records[a].affected_employee_id == null ) {
				records[a].parseMessage = employee_name_link + ' has created ' + parseWordArticle(records[a].title) + " <span class='green'>request</span>.";
				// }else{
				// records[a].parseMessage = employee_name_link + " has <span class='green'>requested</span> " + parseWordArticle(records[a].title) + " for " + employee_affected_name_link + ".";
				//	}

				// display info header
				if (records[a].important_display_fields != null) records[a].importantDisplayInfo += "<div class='log_important_item'>Where the criteria is as follows:</div>";
				break;
			}
			case 'APPROVE': {
				if (records[a].affected_employee_id == null)
				{
					records[a].parseMessage = employee_name_link + " has <span class='green'>approved</span> " + parseWordArticle(records[a].title) + ' entry.';
				} else
				{
					records[a].parseMessage = employee_name_link + " has <span class='green'>approved</span> " + parseWordArticle(records[a].title) + ' for ' + employee_affected_name_link;
				}

				// display info header
				if (records[a].important_display_fields != null) records[a].importantDisplayInfo += "<div class='log_important_item'>Where the criteria is as follows:</div>";
				break;
			}
			case 'FINALIZE': {
				if (records[a].affected_employee_id == null)
				{
					records[a].parseMessage = employee_name_link + " has <span class='green'>finalised</span> " + parseWordArticle(records[a].title) + ' entry.';
				} else
				{
					records[a].parseMessage = employee_name_link + " has <span class='green'>finalised</span> " + parseWordArticle(records[a].title) + ' for ' + employee_affected_name_link;
				}

				// display info header
				if (records[a].important_display_fields != null) records[a].importantDisplayInfo += "<div class='log_important_item'>Where the criteria is as follows:</div>";
				break;
			}
			case 'REJECT': {
				if (records[a].affected_employee_id == null)
				{
					records[a].parseMessage = employee_name_link + " has <span class='red'>rejected</span> " + parseWordArticle(records[a].title) + ' entry.';
				} else
				{
					records[a].parseMessage = employee_name_link + " has <span class='red'>rejected</span> " + parseWordArticle(records[a].title) + ' for ' + employee_affected_name_link;
				}

				// display info header
				if (records[a].important_display_fields != null) records[a].importantDisplayInfo += "<div class='log_important_item'>Where the criteria is as follows:</div>";
				break;
			}

			default: { break; }
		}

		// parse the important display info
		$.each(records[a].important_display_fields, function (k, v) {
			records[a].importantDisplayInfo += "<div class='log_important_item_holder'>";
			records[a].importantDisplayInfo += "<div class='log_important_item'>" + k + ':</div>';
			records[a].importantDisplayInfo += '<i>' + v + '</i>';
			records[a].importantDisplayInfo += '</div>';
		});
		records[a].importantDisplayInfo += "<div class='clear_all'></div>";

		// parse the important developer info
		records[a].importantDevInfo += "<div class='log_important_item'>Where the important data was/is :</div>";
		$.each(records[a].important_fields, function (k, v) {
			records[a].importantDevInfo += "<div class='log_important_item_holder'>";
			records[a].importantDevInfo += "<div class='log_important_item'>" + k + ':</div>';
			records[a].importantDevInfo += v;
			records[a].importantDevInfo += '</div>';
		});
		records[a].importantDevInfo += "<div class='clear_all'></div>";
	}

	return records;
}
